import { api } from '../lib/api';

export interface UserInfo {
  uid: string;
  displayName: string;
  email: string;
  photoURL: string;
  isAdmin?: boolean;
  isBlocked?: boolean;
  inboundHandle?: string | null;
  inboundHandle2?: string | null;
  createdAt?: string | null;
}

export async function findUserByEmail(email: string): Promise<UserInfo | null> {
  try {
    return await api<UserInfo | null>(`/api/auth/users/lookup?email=${encodeURIComponent(email.trim())}`);
  } catch {
    return null;
  }
}

export async function getUsersByIds(userIds: string[]): Promise<UserInfo[]> {
  if (userIds.length === 0) return [];
  try {
    return await api<UserInfo[]>(`/api/auth/users/lookup?ids=${userIds.join(',')}`);
  } catch {
    return [];
  }
}

export async function getAllUsers(): Promise<UserInfo[]> {
  return api<UserInfo[]>('/api/admin/users');
}

export async function setUserBlocked(uid: string, blocked: boolean): Promise<void> {
  await api(`/api/admin/users/${uid}`, {
    method: 'PUT',
    body: JSON.stringify({ isBlocked: blocked }),
  });
}

export async function setUserAdmin(uid: string, isAdmin: boolean): Promise<void> {
  await api(`/api/admin/users/${uid}`, {
    method: 'PUT',
    body: JSON.stringify({ isAdmin }),
  });
}

export async function updateUser(uid: string, fields: {
  displayName?: string;
  inboundHandle?: string;
  inboundHandle2?: string;
}): Promise<void> {
  await api(`/api/admin/users/${uid}`, {
    method: 'PUT',
    body: JSON.stringify(fields),
  });
}
